__turbopack_context__.v({
  "fieldContainer": "_23EVqW_fieldContainer",
  "makeField": "_23EVqW_makeField",
  "manufacturingYearField": "_23EVqW_manufacturingYearField",
  "modelField": "_23EVqW_modelField",
  "validationErrorContainer": "_23EVqW_validationErrorContainer",
  "validationErrorMake": "_23EVqW_validationErrorMake",
  "validationErrorManufacture": "_23EVqW_validationErrorManufacture",
  "validationErrorModel": "_23EVqW_validationErrorModel",
  "validationErrorVariant": "_23EVqW_validationErrorVariant",
  "validationErrorVehicleType": "_23EVqW_validationErrorVehicleType",
  "validationErrorWeight": "_23EVqW_validationErrorWeight",
  "validationErrorYear": "_23EVqW_validationErrorYear",
  "variantField": "_23EVqW_variantField",
  "vehicleTypeField": "_23EVqW_vehicleTypeField",
  "weightField": "_23EVqW_weightField",
  "yearField": "_23EVqW_yearField",
});
